import React, { Component } from 'react'
import '../styles/GiftCard.css'
import Navbar from './Navbar'
import Footer from './Footer'
import GiftCardPlayerCard from './GiftCardPlayerCard'
import GiftCardCover from '../images/GiftCard/giftCardCover.png'
import {Helmet} from 'react-helmet'
import { withRouter } from 'react-router-dom'
import smoothscroll from 'smoothscroll'
import { injectIntl, defineMessages } from 'react-intl'
import { API_ROOT } from '../api-config'
import { Cookies } from 'react-cookie-banner'

const paperCardShippingCost = 2

const GiftCardCoverStyle = {
  backgroundImage: `url(${GiftCardCover})`
}

const removeTransition = (element) => {
  element.classList.remove("site-transition--visible")
}

const buildFormBody = (body) => {
  let formBody = []

  for (let property in body) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(body[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&")

  return formBody
}

class GiftCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      numberOfPlayers: null,
      numberOfGames: null,
      paperCard: null,
      price: 0,
      validatesNumberOfPlayers: true,
      validatesNumberOfGames: true,
      validatesPaperCard: true,
      isTop: true,
      nbPlayers: [1, 2, 3, 4, 5],
      prices: { "prix1j": 0, "prix2j": 0, "prix3j": 0, "prix4j": 0, "prix5j": 0, "prix6j": 0, "prixteambuilding": 0 },
      display: false
    }

    this.props.getPrices([], false).then((output) => {
      this.setState({ prices: output, display: true });
    })
    .catch((e) => {
      console.error(e);
    });
  }

  giftCardGamesStyle = (numberOfGames) => {
    if (this.state.numberOfGames === numberOfGames) {
      return "gift-card-game-unit gift-card-unit--selected"
    } else {
      return "gift-card-game-unit"
    }
  }

  handlePlayerSelect = (numberOfPlayers) => {
    this.setState({
      numberOfPlayers: numberOfPlayers,
      price: this.getPrice(numberOfPlayers, this.state.numberOfGames, this.state.paperCard),
      validatesNumberOfPlayers: true
    })
    smoothscroll(document.getElementById("gift-card-step-2"))
  }

  handleNumberOfGames = (numberOfGames) => {
    this.setState({
      numberOfGames: numberOfGames,
      price: this.getPrice(this.state.numberOfPlayers, numberOfGames, this.state.paperCard),
      validatesNumberOfGames: true
    })
    smoothscroll(document.getElementById("gift-card-step-3"))
  }

  handleShipping = (paperCard) => {
    this.setState({
      paperCard: paperCard,
      price: this.getPrice(this.state.numberOfPlayers, this.state.numberOfGames, paperCard),
      validatesPaperCard: true
    })
  }

  priceForShipping = paperCard => paperCard ? 2 : 0

  getPrice = (numberOfPlayers, numberOfGames, paperCard) => {

    return parseInt(this.state.prices["prix" + numberOfPlayers + "j"]) * numberOfGames + this.priceForShipping(paperCard)
  }

  validatesOptions = () => {
    if (this.state.numberOfGames === null) {
      this.setState({ validatesNumberOfGames: false })
    }
    if (this.state.numberOfPlayers === null) {
      this.setState({ validatesNumberOfPlayers: false })
    }
    if (this.state.paperCard === null) {
      this.setState({ validatesPaperCard: false })
    }
  }

  optionsAreAllSelected = () => {
    return this.state.numberOfGames !== null && this.state.numberOfPlayers !== null && this.state.paperCard !== null
  }

  postCreateOrder = async (slot) => {
    const url = `${API_ROOT}FrontCreateOrderWithVoucher.php`
    const postalSend = this.state.paperCard ? "1" : "0"
    const price = this.state.paperCard ? (this.state.price - paperCardShippingCost) : this.state.price

    const body = {
      id_company: "30",
      voucher_value: price.toString(),
      nb_player: this.state.numberOfPlayers.toString(),
      postal_send: postalSend
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(async (response) => response.json())
    .then(async (data) => {
      const cookies = new Cookies()
      const newVoucher = {
        id_voucher: data.voucher_added.id_voucher,
        id_voucher_token: data.voucher_added.id_voucher_token,
        players: this.state.numberOfPlayers,
        games: this.state.numberOfGames,
        price: this.state.price,
        paper_card: this.state.paperCard
      }
      const vouchers = []
      vouchers.push(newVoucher)
      cookies.set('vouchers', vouchers, { path: '/', expires: new Date('2040-12-17T03:24:00') })
      cookies.set('orderDetailsVouchers', data, { path: '/', expires: new Date('2040-12-17T03:24:00') })

      if (cookies.get("bookings")) {
        await this.deleteAllBookings()
        cookies.remove("bookings")
      }

      if (cookies.get("orderDetails")) {
        cookies.remove("orderDetails")
      }

      if (cookies.get("bookingsTokens")) {
        cookies.remove("bookingsTokens")
      }
    })
    .catch(error => console.log(error))
  }

  deleteAllBookings = async () => {
    const cookies = new Cookies()
    const bookings = cookies.get("bookings")
    const tokens = cookies.get("bookingsTokens")
    const url = `${API_ROOT}FrontDeleteRoomReservation.php`

    bookings.forEach(booking => {
      let token = tokens.find(x => x.id_room_reservation.toString() === booking.id)

      const body = {
        id_reservation: booking.id.toString(),
        token_reservation: token.id_room_reservation_token
      }

      return fetch(url, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
        method: 'post',
        body: buildFormBody(body)
      })
      .then(async (response) => response.json())
      .then(async (data) => {
      })
      .catch(error => console.log(error))
    })
  }

  addVoucherToOrder = async () => {
    const url = `${API_ROOT}FrontAddAnotherVoucherToOrder.php`
    const postalSend = this.state.paperCard ? "1" : "0"
    const cookies = new Cookies()
    const idOrder = cookies.get('orderDetailsVouchers').id_order_escape
    const tokenOrder = cookies.get('orderDetailsVouchers').id_order_escape_token

    const body = {
      id_company: "30",
      voucher_value: this.state.price.toString(),
      nb_player: this.state.numberOfPlayers.toString(),
      postal_send: postalSend,
      id_order: idOrder,
      token_order: tokenOrder
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      const cookies = new Cookies()
      const newVoucher = {
        id_voucher: data.voucher_added.id_voucher,
        id_voucher_token: data.voucher_added.id_voucher_token,
        players: this.state.numberOfPlayers,
        games: this.state.numberOfGames,
        price: this.state.price,
        paper_card: this.state.paperCard
      }
      const vouchers = cookies.get("vouchers")
      vouchers.push(newVoucher)
      cookies.set('vouchers', vouchers, { path: '/', expires: new Date('2040-12-17T03:24:00') })
    })
    .catch(error => console.log(error))
  }

  goToCart = async () => {
    if (this.optionsAreAllSelected()) {
      await this.postCreateOrder()
      this.props.history.push({
        pathname: "/cart",
        params: {
          card: this.state
        }
      })
    } else {
      this.validatesOptions()
    }
  }

  componentDidMount() {
    const cookies = new Cookies()
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
          this.setState({ isTop })
      }
    })

    const glitchTransition = document.getElementById("site-transition")
    window.setTimeout(() => {
      glitchTransition.classList.add("site-transition--visible")
      window.setTimeout(() => {
        removeTransition(glitchTransition)
      }, 500)
    }, 10)
  }

  render() {
    const {intl:{formatMessage}} = this.props

    const cardCTAText = this.state.price > 0
      ? `Commander ma carte pour ${this.state.price} €`
      : "Commander ma carte"


    const error = <span id="gift-card-error--numberOfPlayers" className="gift-card-error gift-card-error--hidden">{formatMessage(messages.noOptionError)}</span>

    return (
     <div className="gift-card">
      <Helmet>
        <title>{formatMessage(messages.metaTitle)}</title>
		<meta name="description" content="Un coupon cadeau escape game One Hour : le cadeau parfait !"/>
		<meta property="og:type" content="website"/>
		<meta property="og:url" content="https://www.one-hour.fr/carte-cadeaux/"/>
		<meta property="og:title" content="Carte Cadeaux escape game 🎁 One Hour"/>
		<meta property="og:description" content="Un coupon cadeau escape game One Hour : le cadeau parfait !"/>
		<meta property="og:image" content="https://www.one-hour.fr/static/media/giftCardCover.320c86ec.png"/>
		<meta property="twitter:card" content="summary_large_image"/>
		<meta property="twitter:url" content="https://www.one-hour.fr/carte-cadeaux/"/>
		<meta property="twitter:title" content="Carte Cadeaux - One Hour"/>
		<meta property="twitter:description" content="Un coupon cadeau escape game One Hour : le cadeau parfait !"/>
		<meta property="twitter:image" content="https://www.one-hour.fr/static/media/giftCardCover.320c86ec.png"/>
      </Helmet>
      <Navbar
        isTop={this.state.isTop}
        lang={this.props.lang}
        handleLang={(lang) => this.props.handleLang(lang)} />
      <div className="gift-card-cover" style={GiftCardCoverStyle}></div>
      {this.state.display ? (
        <div className="gift-card-container">
          <div className="gift-card-content">
            <div className="gift-card-content-text">
          <h1>{formatMessage(messages.texth1)}</h1>
              <p>
              {formatMessage(messages.text1)} <br />
              {formatMessage(messages.text2)}
              </p>
              <p>
              {formatMessage(messages.text4)}
              </p>
        <div className="theme-presentation-disclaimer">
                <span>{formatMessage(messages.disclaimer)}</span>
              </div>
            </div>
            <h2>{formatMessage(messages.step1)}<br/>{!this.state.validatesNumberOfPlayers ? error : null}</h2>

              <div className="gift-card-players-container">
                {
                  this.state.nbPlayers.map((value, index) =>
                    <GiftCardPlayerCard
                      key={value}
                      numberOfPlayers={value}
                      selected={value == this.state.numberOfPlayers}
                      price={this.state.prices["prix" + value + "j"]}
                      handlePlayerSelect={numberOfPlayers => this.handlePlayerSelect(numberOfPlayers)}>
                    </GiftCardPlayerCard>
                  )
                }

              </div>
            <h2 style={{ position: "relative" }}>{formatMessage(messages.step2)}<br/>{!this.state.validatesNumberOfGames ? error : null}
              <span id="gift-card-step-2" className="gift-card-step"/></h2>
              <div className="gift-card-games">
                <div
                  className={this.giftCardGamesStyle(1)}
                  onClick={() => this.handleNumberOfGames(1)}
                  >
                  <div className="gift-card-games-validation">
                    <span className="gift-card-player-validation-circle"><i className="fas fa-check"></i></span>
                  </div>
                  <span>1 {formatMessage(messages.game)}</span>
                </div>
                <div
                  className={this.giftCardGamesStyle(2)}
                  onClick={() => this.handleNumberOfGames(2)}
                  >
                  <div className="gift-card-games-validation">
                    <span className="gift-card-player-validation-circle"><i className="fas fa-check"></i></span>
                  </div>
                  <span>2 {formatMessage(messages.games)}</span>
                </div>
                <div
                  className={this.giftCardGamesStyle(3)}
                  onClick={() => this.handleNumberOfGames(3)}
                  >
                  <div className="gift-card-games-validation">
                    <span className="gift-card-player-validation-circle"><i className="fas fa-check"></i></span>
                  </div>
                  <span>3 {formatMessage(messages.games)}</span>
                </div>
              </div>
            <h2>{formatMessage(messages.step3)}<br/>{!this.state.validatesPaperCard ? error : null}
              <span id="gift-card-step-3" className="gift-card-step"/></h2>
            <div className="gift-card-shipping">
              <div
                className={
                this.state.paperCard || this.state.paperCard === null
                  ? "gift-card-shipping-mode"
                  : "gift-card-shipping-mode gift-card-shipping-mode--selected"
              }
                onClick={() => this.handleShipping(false)}
                >
                <div className="gift-card-shipping-validation">
                  <span className="gift-card-player-validation-circle"><i className="fas fa-check"></i></span>
                </div>
                <div className="gift-card-shipping-text">
                  <p>{formatMessage(messages.printingMyself)}</p>
                  <span>{formatMessage(messages.free)}</span>
                </div>
              </div>
              <div
                className={
                this.state.paperCard
                  ? "gift-card-shipping-mode gift-card-shipping-mode--selected"
                  : "gift-card-shipping-mode"
              }
                onClick={() => this.handleShipping(true)}
                >
                <div className="gift-card-shipping-validation">
                  <span className="gift-card-player-validation-circle"><i className="fas fa-check"></i></span>
                </div>
                <div className="gift-card-shipping-text">
                  <p>{formatMessage(messages.paperCard)}</p>
                  <span>{formatMessage(messages.shippingRate)}</span>
                </div>
              </div>
            </div>
            <div onClick={() => this.goToCart()} className="gift-card-cta">
              {cardCTAText}
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      <Footer />
     </div>
    )
  }
}

const messages = defineMessages({
  metaTitle: {
    id: 'gc.metaTitle',
    defaultMessage: 'Carte Cadeaux escape game 🎁 One Hour'
  },
  noOptionError: {
    id: 'gc.noOptionError',
    defaultMessage: 'Veuillez sélectionner une option'
  },
  texth1: {
    id: 'gc.texth1',
    defaultMessage: 'Carte cadeau escape game'
  },
  text1: {
    id: 'gc.text1',
    defaultMessage: 'Assez des cadeaux conventionnels ? Besoin d’une idée originale ?'
  },
  text2: {
    id: 'gc.text2',
    defaultMessage: 'La carte cadeau One Hour Escape Game c’est LE cadeau à faire autours de vous !'
  },
  text3: {
    id: 'gc.text3',
    defaultMessage: 'Le prix des coupons cadeaux est le même que nos tarifs habituels en heure pleine afin que les personnes ayant reçu ce cadeau puissent venir à n’importe quel moment de la semaine.'
  },
  text4: {
    id: 'gc.text4',
    defaultMessage: 'Une fois la commande traitée, vous recevrez un code à offrir à votre famille ou vos amis et vous permettant de réserver gratuitement une session. Compte tenu de la situation sanitaire actuelle le coupon cadeau One Hour est exceptionnelement valable 2 ans.'
  },
  step1: {
    id: 'gc.step1',
    defaultMessage: 'Etape 1 - Pour combien de joueurs ?'
  },
  step2: {
    id: 'gc.step2',
    defaultMessage: 'Etape 2 - Combien de parties ?'
  },
  step3: {
    id: 'gc.step3',
    defaultMessage: "Etape 3 - Type d'envoi du bon ?"
  },
  giftCard: {
    id: 'gc.giftCard',
    defaultMessage: "Carte Cadeaux"
  },
  player: {
    id: 'gc.player',
    defaultMessage: "joueur"
  },
  players: {
    id: 'gc.players',
    defaultMessage: "joueurs"
  },
  game: {
    id: 'gc.game',
    defaultMessage: "partie"
  },
  games: {
    id: 'gc.games',
    defaultMessage: "parties"
  },
  printingMyself: {
    id: 'gc.printingMyself',
    defaultMessage: "Une version e-mail que j'imprimerai moi-même"
  },
  free: {
    id: 'gc.free',
    defaultMessage: "GRATUIT"
  },
  paperCard: {
    id: 'gc.paperCard',
    defaultMessage: "Je souhaite recevoir ma carte cadeau par courrier"
  },
  shippingRate: {
    id: 'gc.shippingRate',
    defaultMessage: "2 € supplémentaires"
  },
  disclaimer: {
    id: 'gc.disclaimer',
    defaultMessage: "Le coupon cadeau offert correspond à un bon d'achat. Lors de la réservation il est possible pour le destinataire de compléter l'achat si l'équipe est plus nombreuse (dans la limite de 5 joueurs max)"
  },
})

export default withRouter(injectIntl(GiftCard))



// WEBPACK FOOTER //
// ./src/components/GiftCard.js